<template>
    <!-- Authors Table Card -->
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <!-- <template #title>
            <a-row type="flex" align="middle">
                <a-col :span="24" :md="12">
                    <h5 class="font-semibold m-0">客户转化率·数据表格</h5>
                </a-col>
            </a-row>
        </template> -->
        <a-row :gutter="24" type="flex">
            <!-- Authors Table Column -->
            <a-col :span="24" class="mb-24">
                <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
                    <a-form-item label="会员名称">
                        <a-input v-model="dataForm.customer_name" allowClear placeholder="会员姓名" />
                    </a-form-item>
                    <a-form-item label="扫码员工姓名">
                        <a-input v-model="dataForm.operator_name" allowClear placeholder="扫码员工姓名" />
                    </a-form-item>
                    <a-form-item label="随行管家">
                        <a-select v-model="dataForm.employee_id" allowClear placeholder="请选择随行管家"
                            style="width: 200px">
                            <a-select-option v-for="item in employeeList" :key="item.user_id" :value="item.user_id">
                                {{ item.real_name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="会员入场时间">
                        <a-range-picker @change="onChangeTime" allowClear value-format="yyyy/MM/DD" />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
                    </a-form-item>
                    <a-form-item>
                        <a-button @click="exportHandle" type="primary"
                            :loading="dataListLoading || exportLoading">导出</a-button>
                    </a-form-item>
                </a-form>

                <a-table :scroll="{ x: 1000 }" :columns="columns" :data-source="dataList" :pagination="false"
                    rowKey="scan_id" :loading="dataListLoading">
                    <template slot="employees" slot-scope="employees">
                        <div v-if="employees && employees.length > 0">
                            <a-tag v-for="(emp, index) in employees" :key="emp.id" color="blue" style="margin-bottom: 4px;">
                                {{ emp.user && emp.user.real_name }}
                            </a-tag>
                        </div>
                        <span v-else>-</span>
                    </template>
                    <template slot="footer" slot-scope="currentPageData">
                        累积入场人数：{{ totalQuantity }}
                    </template>
                </a-table>
            </a-col>
            <!-- / Authors Table Column -->
        </a-row>

        <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
    </a-card>
    <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
export default {
    mixins: [viewModule],
    components: {
    },
    data() {
        return {
            exportFileName: "门店会员入场记录导出",
            mixinViewModuleOptions: {
                getDataListURL: "/admin/customer/storeEntry",
                exportURL: "/admin/customer/storeEntryExport",
            },
            totalQuantity: 0,
            employeeList: [],
            dataForm: {
                customer_name: "",
                operator_name: "",
                employee_id: undefined,
                join_start: "",
                join_end: "",
            },
            columns: [
                {
                    title: "会员姓名",
                    dataIndex: "customer_name",
                    width: 200,
                },
                {
                    title: "入场身份",
                    dataIndex: "vip",
                    width: 200
                },
                {
                    title: "入场时间",
                    dataIndex: "join_time",
                    width: 200
                },
                {
                    title: "入场扫码员工",
                    dataIndex: "operator_name",
                    width: 200
                },
                {
                    title: "入场人数",
                    dataIndex: "quantity",
                    width: 100
                },
                {
                    title: "随行管家",
                    dataIndex: "employees",
                    scopedSlots: { customRender: "employees" },
                    width: 200
                },
                //   {
                //     title: "",
                //     scopedSlots: { customRender: "editBtn" },
                //     width: 200,
                //     fixed: "right",
                //   },
            ],
        };
    },
    methods: {
        onChangeTime(e) {
            if (e.length == 2) {
                this.dataForm.join_start = `${e[0]} 00:00:00`
                this.dataForm.join_end = `${e[1]} 23:59:59`
            } else {
                this.dataForm.join_start = undefined
                this.dataForm.join_end = undefined
            }
        },
        queryAfter(res) {
            this.totalQuantity = res.data.totalQuantity
        },
        // 获取员工列表
        getEmployeeList() {
            this.$http({
                url: "/wxh5/getEmployeeList",
                method: "get",
            }).then(({ data }) => {
                if (data && data.result) {
                    this.employeeList = data.result || [];
                }
            });
        }
    },
    mounted() {
        this.getEmployeeList();
    }
};
</script>